import React from 'react';
import { Router, Route, Redirect, Switch, withRouter } from "react-router";
import { createBrowserHistory } from 'history';
import request from '../utils/agent';

const browserHistory = createBrowserHistory()

// Template
import MainTemplate from 'components/Templates/Main';
import AdminTemplate from 'components/Templates/Admin';
import UserTemplate from 'components/Templates/User';



// Route Pages
import Home from './Home';
import UserLogin from './UserLogin';
import UserSignupHome from './UserSignupHome';
import UserSignupSuccess from './UserSignupSuccess'
import DistrubutorSignupSuccess from './DistributorSignupSuccess';
import Resources from './Resources';

// Dashboard Pages
import Admin from './Admin';
import AdminCsms from './AdminCsms';
import AdminProfile from './AdminProfile';
import AdminReports from './AdminReports';
import AdminUsers from './AdminUsers';
import AdminNewCsm from './AdminNewCsm';
import AdminViewCsm from './AdminViewCsm';
import AdminViewUser from './AdminViewUser';
import AdminCreateReseller from './AdminCreateReseller';
import AdminCreateDistributor from './AdminCreateDistributor';
import AdminCreateDeveloper from './AdminCreateDeveloper';
import AdminCreateArchitect from './AdminCreateArchitect';
import AdminCreateAdmin from './AdminCreateAdmin';
import AdminCreateEmployee from './AdminCreateEmployee'
import User from './User';
import UserAgreement from './UserAgreement';
import UserCreatePassword from './UserCreatePassword';
import UserEmployees from './UserEmployees';
import UserLocations from './UserLocations';
import UserNewEmployees from './UserNewEmployees';
import UserViewEmployees from './UserViewEmployees';
import UserForgotPassword from './UserForgotPassword';
import UserMarketing from './UserMarketing';
import UserProfile from './UserProfile';
import UserResources from './UserResources';
import UserSupport from './UserSupport';
import UserTraining from './UserTraining';
import UserTrainingModule from './UserTraining/module';
import UserWhereToBuy from './UserWhereToBuy';


const routerUpdated = () => {
  console.log('Router Updated');
}

const authHandler = {
  isAuthenticated: window.localStorage.getItem('token') ? true : false,
  setAuth(token) {
    this.isAuthenticated = true;
    window.localStorage.setItem('token', token);
  },
  getUserAuth(email, pass) {
      return request.post('/api/auth/login')
          .send({
              email: email,
              password: pass
          })
          .then(resp => [null, resp])
          .catch(err => [err]);
  },
  getUserRole() {
      return request.get('/api/role')
          .then(resp => [null, resp.body])
          .catch(err => [err]);
  }
}

const PublicRoutes = ({...props}) => (
  <MainTemplate>
    <Switch>
        <Route exact path='/' component={Home} />
        <Route exact path='/resources' component={Resources} />
        <Route exact path='/login' component={() => <UserLogin authHandler={authHandler} />} />
        <Route exact path='/signup' component={UserSignupHome} />
        <Route exact path='/signup/user' component={UserSignupSuccess} />
        <Route exact path='/signup/reseller' component={DistrubutorSignupSuccess} />
        <Route exact path='/password/reset' component={UserForgotPassword} />
        <Route exact path='/password/:action(create|reset)/:token' component={(props) => <UserCreatePassword authHandler={authHandler} {...props}/>}/>
        <Route path='/*' render = {({}) => (
        <h1>404</h1>
     )} />
    </Switch>
  </MainTemplate>
)

// Move to an actual template layout
const AdminRoutes = ({...props}) => (
  authHandler.isAuthenticated === true ?
  <AdminTemplate>
    <Switch>
      <Route exact path='/admin' render = {({}) => (
        <Redirect to={{
          pathname: '/admin/dashboard'
        }} />
      )} />
        <Route exact path='/admin/dashboard' component={Admin} />
        <Route exact path='/admin/profile' component={AdminProfile} />
        <Route exact path='/admin/users/:filter' component={AdminUsers} />
        <Route exact path='/admin/reports' component={AdminReports} />
        <Route exact path='/admin/csms' component={AdminCsms} />
        <Route exact path='/admin/csm/:id' component={AdminViewCsm} />
        <Route exact path='/admin/newCsm' component={AdminNewCsm} />
        <Route exact path='/admin/user/:id' component={AdminViewUser}/>
        <Route exact path='/admin/newUser' component={AdminCreateReseller}/>
        <Route exact path='/admin/newDistributor' component={AdminCreateDistributor}/>
        <Route exect path='/admin/newDeveloper' component={AdminCreateDeveloper}/>
        <Route exect path='/admin/newArchitect' component={AdminCreateArchitect}/>
        <Route exect path='/admin/newAdmin' component={AdminCreateAdmin}/>
        <Route exect path='/admin/newEmployee' component={AdminCreateEmployee}/>
        <Route path='/admin/*' render = {({}) => (
        <h1>404</h1>
       )} />
    </Switch>
  </AdminTemplate>
  : <Redirect to={{
    pathname: '/login'
  }} />
);


//Move to user template layout

const UserRoutes = ({...props}) =>(
    authHandler.isAuthenticated === true ?
        <UserTemplate>
            <Switch>
                <Route exact path='/user' render={({}) => (
                    <Redirect to={{pathname:'/user/dashboard'}}/>
                )}/>
                <Route exact path='/user/dashboard' component={User}/>
                <Route exact path='/user/profile' component={UserProfile}/>
                <Route exact path='/user/training' component={UserTraining}/>
                <Route exact path='/user/training/:module' component={UserTrainingModule}/>
                <Route exact path='/user/98763456' component={UserResources}/>
                <Route exact path='/user/34567123' component={UserMarketing}/>
                <Route exact path='/user/where-to-buy' component={UserWhereToBuy}/>
                <Route exact path='/user/support' component={UserSupport}/>
                <Route exact path='/user/employees' component={UserEmployees}/>
                <Route exact path='/user/employees/new-employee' component={UserNewEmployees}/>
                <Route exact path='/user/employees/:id' component={UserViewEmployees}/>
                <Route exact path='/user/locations' component={UserLocations}/>
                <Route exact path='/user/agreement' component={UserAgreement}/>

                <Route path='/user/*' render = {({}) => (
                    <h1>404</h1>
                )}/>
            </Switch>
        </UserTemplate>
        : <Redirect to={{
            pathname:'/login'}}/>
);



export default (
  <Router onUpdate={routerUpdated} history={browserHistory}>
      <Switch>
          <Route path="/user" render={props => <UserRoutes {...props}/>} />
          <Route path="/admin" render={props => <AdminRoutes {...props} />} />
          <Route path="/" render={props => <PublicRoutes {...props} />} />
      </Switch>
  </Router>
);


// WEBPACK FOOTER //
// ./src/routes/index.js